import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Outlet />
      <small style={{ position: 'fixed', bottom: '0px', color: '#FFFFFF' }}>
        2023 xForceDev
      </small>
    </>
  )
};

export default Layout;